import { jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmMicrophone } from '@websolutespa/bom-mixer-icons';
import { useLlm } from '../../../useLlm/useLlm.js';
import style from './page-dictate.module.scss.js';

const PageDictate = () => {
  const label = useLabel();
  const {
    recognizeStart,
    recognizeStop,
    hasSpeechRecognitionSupport
  } = useLlm(state => state.actions);
  const hasSpeechRecognition = hasSpeechRecognitionSupport();
  return hasSpeechRecognition && jsx("button", {
    type: "button",
    className: getClassNames(style.dictate),
    "aria-label": label('llm.dictate'),
    onMouseDown: () => recognizeStart(),
    onMouseUp: () => recognizeStop(),
    onTouchStart: () => recognizeStart(),
    onTouchEnd: () => recognizeStop(),
    children: jsx(IconLlmMicrophone, {})
  });
};

export { PageDictate };
//# sourceMappingURL=page-dictate.js.map
